import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink],
  template: `
    <header class="header">
      <div class="header-content">
        <a routerLink="/" class="logo-link">
          <img src="assets/apk-logo.png" alt="APK Gent" class="logo" />
        </a>
        <nav class="nav">
          <a href="https://apk-gent.be" target="_blank" class="nav-link nav-link-home" title="Naar APK Gent website">Homepage APK Gent</a>
         <!-- <a routerLink="/" class="nav-link">Voorstellingen</a>
          <a routerLink="/inschrijven" class="nav-link nav-link-primary">Tickets reserveren</a> -->
        </nav>
      </div>
    </header>
  `,
  styles: [`
    .header {
      background: linear-gradient(135deg, #CC6666 0%, #b85555 100%);
      padding: 1rem;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .header-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .logo-link {
      display: flex;
      align-items: center;
    }

    .logo {
      height: 100px;
      width: auto;
    }

    .nav {
      display: flex;
      gap: 1rem;
    }

    .nav-link {
      color: white;
      text-decoration: none;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      font-weight: 500;
      transition: background-color 0.2s;
    }

    .nav-link:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .nav-link-primary {
      background-color: #088673;
    }

    .nav-link-primary:hover {
      background-color: #066b5c;
    }

    .nav-link-home {
      background-color: rgba(255, 255, 255, 0.15);
    }

    .nav-link-home:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }

    @media (max-width: 600px) {
      .logo {
        height: 45px;
      }

      .nav-link {
        padding: 0.4rem 0.8rem;
        font-size: 0.9rem;
      }
    }
  `]
})
export class HeaderComponent {}
